import React, {useEffect, useState} from 'react';
import AuthService from '../Services/AuthService';
import './PreRegistroStep1.css';

const preRegSessionKeys = {
  user: 'pre_registration_user',
  curp: 'pre_registration_curp',
  name: 'pre_registration_name',
  ObjectId: 'pre_registration_ObjectId',
  expiresAt: 'pre_registration_expires_at',
};

const preRegSigningKey = 'pre_registration_signing';
const preRegSigningExpiresKey = 'pre_registration_signing_expires_at';
const preregistroRecidKey = 'preregistro_recid';

const signedErrorMessage = 'No pudimos actualizar tu información.\nIntenta nuevamente más tarde.';

const isValidFutureTimestamp = (value) => {
  const parsedValue = Number(value);
  return Number.isFinite(parsedValue) && parsedValue > Date.now();
};

export default function PreRegistroSigned() {
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const signingValue = localStorage.getItem(preRegSigningKey);
    const signingExpiresAt = localStorage.getItem(preRegSigningExpiresKey);
    const sessionUser = localStorage.getItem(preRegSessionKeys.user);
    const sessionCurp = localStorage.getItem(preRegSessionKeys.curp);
    const sessionName = localStorage.getItem(preRegSessionKeys.name);
    const sessionObjectId = localStorage.getItem(preRegSessionKeys.ObjectId);
    const sessionExpiresAt = localStorage.getItem(preRegSessionKeys.expiresAt);

    const hasValidSigning = signingValue === 'true' && isValidFutureTimestamp(signingExpiresAt);
    const hasValidSession = !!sessionUser && !!sessionCurp && !!sessionName && !!sessionObjectId && isValidFutureTimestamp(sessionExpiresAt);

    if (!hasValidSigning || !hasValidSession) {
      setErrorMessage(signedErrorMessage);
      return;
    }

    AuthService.updateCandidate({
      ObjectId: sessionObjectId,
      contractEsigURL: 'Signed',
    })
      .then((updateResponse) => {
        const updateData = updateResponse && updateResponse.data;
        if (!updateData || updateData.success !== true) {
          setErrorMessage(signedErrorMessage);
          return;
        }

        return AuthService.getCandidate(sessionObjectId).then((candidateResponse) => {
          const candidatePayload = candidateResponse && candidateResponse.data;
          const candidateData = candidatePayload && candidatePayload.candidateData;
          const recid = (candidateData && candidateData.recid) || localStorage.getItem(preregistroRecidKey);

          if (!recid) {
            setErrorMessage(signedErrorMessage);
            return;
          }

          window.location.href = '/preregistro/?&recid=' + recid;
        });
      })
      .catch(() => {
        setErrorMessage(signedErrorMessage);
      });
  }, []);

  return (
    <div className="prereg-step1-page prereg-upload-page">
      <div className="prereg-step1-card">
        <div className="prereg-step1-content prereg-password-content prereg-upload-content">
          {errorMessage ? (
            <div className="prereg-step1-error" style={{whiteSpace: 'pre-line'}}>{errorMessage}</div>
          ) : (
            <div className="prereg-upload-screen">
              <h3 className="prereg-upload-title">Actualizando información...</h3>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
